<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Larval Data</h1>
        <div class="pull-right btn-group">
          <button
            class="pointer btn btn-lg btn-primary"
            v-on:click="form.showEdit({})"
          >
            Create New
          </button>
        </div>
      </div>
    </div>

    <div class="panel">
      <search-fields :form="form" :fields="searchFieldsList"></search-fields>

      <loading :working="form.working()"></loading>

      <div class="panel-body" v-if="!form.working()">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Larval Site</th>
                <th>Applied</th>
                <th>Applicator</th>
                <th>Equipment Used</th>
                <th>Eggs</th>
                <th>Larvae</th>
                <th>Pupae</th>
                <th>Adults</th>
                <th>Visual Monitoring</th>
                <th>Control Action</th>
                <th>Chemical</th>
                <th>Amount (oz)</th>
                <th>Appl. Rate</th>
                <th>Area Treated</th>
                <th>Sample Number</th>
                <th>Service Request</th>
                <th>Larval Stages</th>
                <th>Work Status</th>
                <th width="120"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in form.list">
                <td>{{ item.attributes.larvalSiteName }}</td>
                <td>
                  {{ item.attributes.appliedDate | date }} @
                  {{ item.attributes.appliedTime | time }}
                </td>
                <td>{{ applicatorName(item.attributes.applicatorId) }}</td>
                <td>{{ equipmentName(item.attributes.lequipmentId) }}</td>
                <td>{{ larvaCountName(item.attributes.eggs) }}</td>
                <td>{{ larvaCountName(item.attributes.larvae) }}</td>
                <td>{{ larvaCountName(item.attributes.pupae) }}</td>
                <td>{{ larvaCountName(item.attributes.adults) }}</td>
                <td>
                  <i
                    class="fa"
                    :class="{
                      'fa-check-square-o':
                        item.attributes.vizualMonitorPerformed,
                      'fa-square-o': !item.attributes.vizualMonitorPerformed,
                    }"
                  ></i>
                </td>
                <td>{{ controlAction(item.attributes.controlActionId) }}</td>
                <td>{{ chemicalName(item.attributes.lchemicalId) }}</td>
                <td>{{ item.attributes.amount }}</td>
                <td>{{ applicationRate(item.attributes.applicationRate) }}</td>
                <td>{{ item.attributes.areaTreated }}</td>
                <td>{{ item.attributes.sampleNumber }}</td>
                <td>
                  <router-link
                    v-if="form.data.serviceRequestId"
                    :to="{
                      name: 'data-service-request-details',
                      params: { id: form.data.serviceRequestId },
                    }"
                    >view</router-link
                  >
                </td>
                <td>{{ item.attributes.lStages }}</td>
                <td>{{ item.attributes.workStatus }}</td>
                <td>
                  <!--<a class="pointer text-primary" v-on:click="form.showEdit({id: item.id})"><i class="fa fa-pencil" style="margin-right: 10px;"></i></a>-->
                  <router-link
                    :to="{
                      name: 'data-larvicide-details',
                      params: { id: item.id },
                    }"
                    ><i class="fa fa-ellipsis-h mr-10" title="Add Data"></i
                  ></router-link>
                  <router-link
                    :to="{
                      name: 'data-larval-site-details',
                      params: { id: item.attributes.larvalSiteId },
                    }"
                    title="Larval Site"
                    ><i class="fa fa-file-o mr-10"></i
                  ></router-link>
                  <a
                    class="pointer text-danger"
                    v-on:click="form.destroy(item.id)"
                    ><i class="fa fa-times" title="Delete"></i
                  ></a>
                </td>
              </tr>
            </tbody>
            <pager :form="form"></pager>
          </table>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>
  </div>
</template>

<script>
import LarvicidesService from '@/services/LarvicidesService';
import Form from '@/utils/form';
import loader from '@/utils/loader';
import siteForm from '@/components/forms/larvicide';
import pager from '@/components/forms/pager';
import searchFields from '@/components/search_fields';
import loading from '@/components/loading';

import store from '@/store';

export default {
  name: 'larvacide',

  components: {
    pager,
    siteForm,
    searchFields,
    loading,
  },

  props: ['id', 'type'],

  data() {
    return {
      searchFieldsList: { site: 'Site', zone: 'Zone', location: 'Location' },
      form: new Form(LarvicidesService, {
        vizualMonitorPerformed: true,
        workStatus: 'Completed by technician',
      }),
    };
  },

  methods: {
    siteName(id) {
      return this.$store.getters.siteNameById(id);
    },
    contractName(id) {
      return this.$store.getters.contractNameById(id);
    },
    applicatorName(id) {
      return this.$store.getters.applicatorNameById(id);
    },
    windDirection(id) {
      return this.$store.getters.windDirectionNameById(id);
    },
    equipmentName(id) {
      return this.$store.getters.lEquipementNameById(id);
    },
    vizualMonitor(id) {
      return this.$store.getters.vizualMonitorNameById(id);
    },
    controlAction(id) {
      return this.$store.getters.controlActionNameById(id);
    },
    chemicalName(id) {
      return this.$store.getters.lChemicalNameById(id);
    },
    larvaCountName(id) {
      return this.$store.getters.larvaCountNameById(id);
    },
    applicationRate(id) {
      return this.$store.getters.larvalAppRateNameById(id);
    },
  },

  created() {
    if (
      this.$route.path.indexOf('larvicide') > -1 &&
      this.$props.type === 'sr'
    ) {
      window.bus.$on('item-created', () => {
        this.$router.push({
          name: 'data-service-request-details',
          params: { id: this.$props.id },
        });
      });
    } else if (
      this.$route.path.indexOf('larvicide') > -1 &&
      this.$props.id === 'new'
    ) {
      window.bus.$on('item-created', () => {
        setTimeout(() => {
          if (this.$route.path.indexOf('larvicide') > -1) {
            this.form.showEdit({});
          }
        }, 1000);
      });
    }

    $(document).on('hide.bs.modal', () => {
      if (
        this.$route.path.indexOf('larvicide') > -1 &&
        this.$props.type === 'sr'
      ) {
        this.$router.push({
          name: 'data-service-request-details',
          params: { id: this.$props.id },
        });
      }
    });
  },

  mounted() {
    loader.lookups().then(() => {
      this.form.getList();
    });

    if (this.$props.id) {
      switch (this.$props.type) {
        case 'ls':
          this.form.data.larvalSiteId = this.$props.id;
          break;
        case 'sr':
          this.form.data.serviceRequestId = this.$props.id;
          break;
        case 's':
          this.form.siteSearch.term = this.siteName(this.$props.id);
          this.form.onSiteSearch('siteId');
          break;
      }
      this.form.showEdit({});
    }
  },
};
</script>

<style lang="scss"></style>
